export default __webpack_public_path__ + "static/media/bensound-goinghigher.c0c7118b.mp3";